import { useBootstrap } from '../context/BootstrapContext'

export function useSiteImages() {
  const { data, loading } = useBootstrap()
  return { siteImages: data.siteImages, loading }
}
